import { render, staticRenderFns } from "./Specialties.vue?vue&type=template&id=5a869b48"
import script from "./Specialties.vue?vue&type=script&lang=js"
export * from "./Specialties.vue?vue&type=script&lang=js"
import style0 from "./Specialties.vue?vue&type=style&index=0&id=5a869b48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports